import { render } from "./additionalTax.vue?vue&type=template&id=005c3286&scoped=true"
import script from "./additionalTax.vue?vue&type=script&lang=js"
export * from "./additionalTax.vue?vue&type=script&lang=js"

import "./additionalTax.vue?vue&type=style&index=0&id=005c3286&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005c3286"]])

export default __exports__